/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Panel, BackgroundPanel, TableAdvanced } from "vr-react-components";
import { handleToggleEngine } from "../../../handlers/HomeRoomHandlers";
import { handleSetKeyboard } from "../../../handlers/PrivateHandlers";
import BarPanelWidget from "../../../widgets/BarWidget/BarPanelWidget";
import CriticalJobsWidget from "../../../widgets/CriticalJobsWidget/CriticalJobsWidget";
import DisplayingPlansWidget from "../../../widgets/DisplayingPlansWidget";

const RightPanelVR = React.memo(({ width, height }) => {
    const engines = useSelector((state) => state.user.engines);
    const currentRoom = useSelector((state) => state.room.history[0].ID)
    const canModify = useSelector((state) => state.private.device.canModify);

    const engineData = [
        ["Name", "Owner", "Type", "Status"],
        ...engines.list.map((x) => { return [x.name, x.owner, x.type, x.available] }),
    ]

    const disabledList = [false].concat(engines.list.map((engine) => engine.available))

    const innerWidth = width * 0.9;
    const innerHeight = height * 0.9;
    
    const middlewareForHandleToggleEngine = (i) => {
        const label = engines.list[i].name
        handleToggleEngine(label, engines)
     }

    return (
        <>
            <BackgroundPanel
                width={width / 2}
                height={height}
                position={`${2.5} 0 ${1.5}`}
                repositionate={false}
                rotation="0 -60 0"
            >
                <DisplayingPlansWidget
                    width={innerWidth * 0.5 - innerWidth / 150}
                    height={innerHeight * 0.4 - height * 0.005}
                    position={`0 ${-height / 2 + innerHeight * 0.2 + height * 0.05} ${width / 100
                        }`}
                    backgroundColor="#262626"
                    textSizeDecimal={60 / innerWidth}
                    textOffset={{
                        x: (innerWidth * 0.4) / 20,
                        y: (innerHeight * 0.5) / 20,
                    }}
                    arrows="side"
                />
                <BackgroundPanel
                    width={innerWidth * 0.5 - innerWidth / 150}
                    height={innerHeight * 0.6 - height * 0.005}
                    position={`0 ${height / 2 - innerHeight * 0.3 - height * 0.05} ${width / 100
                        }`}
                    backgroundColor="#262626"
                    title="Engines"
                    textSizeDecimal={60 / innerWidth}
                    textOffset={{
                        x: (innerWidth * 0.4) / 20,
                        y: (innerHeight * 0.5) / 20,
                    }}
                >
                    <TableAdvanced
                        aframeClasses={canModify ? "collidable" : ""}
                        keyboardHandler={handleSetKeyboard}
                        width={innerWidth * 0.45}
                        height={innerHeight * 0.5}
                        search
                        checkbox
                        tableRows={3}
                        position={`0 ${innerHeight * 0.19} ${innerWidth / 100}`}
                        setChecked={(label) => handleToggleEngine(label, engines)}
                        onRowClick={(_, i) => middlewareForHandleToggleEngine(i)}
                        checkboxesState={engines.selected}
                        disabledList={disabledList}
                        data={engineData}
                        disabled={false}
                        inVRMode={true}
                    />
                </BackgroundPanel>
            </BackgroundPanel>
            <BackgroundPanel
                width={width / 2}
                height={height}
                position={`${width / 4} 0 0`}
                rotation="0 -30 0"
            >
                <Panel
                    panel
                    resize
                    aframeClasses={canModify ? "collidable" : ""}
                    width={innerWidth * 0.5 - innerWidth / 150}
                    height={innerHeight * 0.5 - height * 0.005}
                    position={`0 ${-height / 2 + innerHeight * 0.25 + height * 0.05} ${width / 100
                        }`}
                    backgroundColor="#262626"
                    sizeDecimal={30 / (innerHeight / 2)}
                    title="Job Status (grouped data)"
                >
                    <BarPanelWidget
                        grouped
                        stateName={"dataRightChart"}
                        currentRoom={currentRoom}
                        aspectRatio={(width / (height / 2)) * 0.6}
                    />
                </Panel>

                <CriticalJobsWidget
                    width={innerWidth * 0.5 - innerWidth / 150}
                    height={innerHeight * 0.5 - height * 0.005}
                    position={`0 ${height / 2 - innerHeight * 0.25 - height * 0.05} ${width / 100
                        }`}
                    backgroundColor="#262626"
                    textSizeDecimal={30 / (innerHeight / 2)}
                    isClickable
                />
            </BackgroundPanel>
        </>
    );
});

export default RightPanelVR;